<template>
  <button
    class="flex items-center justify-center rounded-full p-3 hover:bg-gray-600_a25 active:bg-gray-600_a35"
    @click="handleClick"
  >
    <IconClose v-if="isMenuOpen" class="h-6 w-6" />
    <IconMenu v-else class="h-6 w-6" />
  </button>
</template>

<script setup lang="ts">
  import { EnumCNMenuIndex, EnumMenuIndex } from '@/stores/menuStore';

  const { isTablet } = useScreen();
  const { isCN } = useLanguage();
  const menuStore = useMenuStore();
  const { currentMenu, isMenuOpen } = storeToRefs(menuStore);

  const handleClick = (): void => {
    isMenuOpen.value = !isMenuOpen.value;

    if (currentMenu.value === null && isMenuOpen.value && isTablet.value) {
      // TODO: 待 CN 選單確定改版後移除
      if (isCN.value) {
        currentMenu.value = EnumCNMenuIndex.SOLUTIONS;
      } else {
        currentMenu.value = EnumMenuIndex.PRODUCTS;
      }
    }
  };
</script>
